import React from 'react';
import { Field, useFormikContext } from 'formik';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup as MUIRadioGroup,
    RadioGroupProps,
} from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib';
import { legalPersonType, personType, translations } from '../../lib/consts';

export type LegalIndividualSelectorProps = {
    selectorType: personType;
};

const LegalIndividualSelector = ({ selectorType }: LegalIndividualSelectorProps) => {
    const { errors, touched } = useFormikContext<GenericObject>();

    const type = `${personType[selectorType]}Type`;

    const RadioGroup = (params: RadioGroupProps) => {
        return (
            <MUIRadioGroup {...params} row sx={{ marginTop: '-15px' }}>
                <FormControlLabel
                    value={legalPersonType.individual}
                    control={<Radio />}
                    label={translations.legalPersonType.INDIVIDUAL}
                />
                <FormControlLabel
                    value={legalPersonType.legal}
                    control={<Radio />}
                    label={translations.legalPersonType.LEGAL}
                />
            </MUIRadioGroup>
        );
    };

    return (
        <>
            <FormControl required={true}>
                <Field name={type} as={RadioGroup} size="big" />

                {touched[type] && errors[type] ? (
                    <FormHelperText error={true}>
                        <>{errors[type]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export default LegalIndividualSelector;
